module.exports = __webpack_public_path__ + "img/_DSC6728.b8082b73.jpg";